import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import DOMPurify from "isomorphic-dompurify"
import closeIcon from "@/public/icons/close-white.svg"
import { selectGenericState, hideToast } from "@/store/features/genericSlice"
import { TOAST_MESSAGE_DEFAULT_DURATION } from "@/constants/index"

import styles from "@/components/core/Toaster/index.module.scss"

const Toaster = ({ onClose }) => {
  const {
    toaster: { message, isVisible },
  } = useSelector(selectGenericState)

  const dispatch = useDispatch()
  const [timeoutVal, setTimeoutVal] = useState(null)
  useEffect(() => {
    if (timeoutVal) {
      clearTimeout(timeoutVal)
      setTimeoutVal(null)
    }
    if (isVisible && !timeoutVal) {
      const tmVal = setTimeout(() => {
        dispatch(hideToast())
      }, TOAST_MESSAGE_DEFAULT_DURATION)
      setTimeoutVal(tmVal)
    }
  }, [isVisible])

  const handleClose = () => {
    if (onClose) {
      onClose()
    } else {
      dispatch(hideToast())
    }
  }
  return (
    <div className={styles.wrapper}>
      <>
        {isVisible && (
          <div className="toast-msg">
            <div className="container kf-react-container toast-msg__content">
              <div
                className="toast-msg__message"
                role="alert"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(message),
                }}
              ></div>
              <div className="toast-msg__close">
                <img src={closeIcon?.src} alt="close" onClick={handleClose} />
              </div>
            </div>
          </div>
        )}
      </>
    </div>
  )
}

Toaster.propTypes = {
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func,
}

export default Toaster
